import { FC } from 'react';

interface PropsImage {
  id: string;
  attributes: {
    name: string;
    alternativeText: string | null;
    width: number;
    height: number;
    formats: any;
    url: string;
    mime: string;
    size: any;
  };
}

interface WhatsInTheBoxPart {
  id: string;
  title: string;
  image?: {
    data: PropsImage;
  };
}

interface WhatsInTheBoxProps {
  content: {
    title: string;
    description: string;
    data: WhatsInTheBoxPart[];
  };
}

export const WhatsInTheBox: FC<WhatsInTheBoxProps> = ({ content }) => {
  return (
    <section className='WhatsInTheBox relative mx-[100px] hidden flex-col items-center rounded-[48px] bg-[#F4F6F8] pb-16 pt-24 min-[1775px]:flex'>
      <h2 className='mb-12 text-center text-4xl font-bold'>{content.title}</h2>
      <div className='relative mx-auto w-[95%]'>
        <div className='flex min-w-max justify-center px-8'>
          {content.data?.map((item, i) => {
            const widths = [433, 440, 50, 75, 35, 30];
            const spacing = [0, 75, 75, 75, 75, 75];
            const itemStyle = {
              width: `${widths[i]}px`,
              marginLeft: i === 0 ? 0 : `${spacing[i]}px`,
              position: 'relative' as const,
              zIndex: 1,
            };
            return (
              <div
                key={item.id || i}
                className='flex flex-col items-center justify-end'
                style={itemStyle}
              >
                {item?.image?.data?.attributes?.url && (
                  <img
                    src={item.image.data.attributes.url}
                    alt={item.title}
                    title={item.title}
                    className='w-full object-contain'
                  />
                )}
              </div>
            );
          })}
        </div>
        <div className='relative z-10 mt-[-5px] rounded-[32px] bg-white px-8 pb-8 pt-8'>
          <div className='flex min-w-max justify-center'>
            {content.data?.map((item, i) => {
              const widths = [433, 440, 50, 75, 35, 30];
              const spacing = [0, 75, 75, 75, 75, 75];
              const itemStyle = {
                width: `${widths[i]}px`,
                marginLeft: i === 0 ? 0 : `${spacing[i]}px`,
                position: 'relative' as const,
              };
              return (
                <div
                  key={item.id || i}
                  className='flex items-center justify-center'
                  style={itemStyle}
                >
                  <span className='text-center text-lg font-medium text-[#6B7280]'>
                    {item.title}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsInTheBox;
